import { useEffect, useSyncExternalStore } from 'react';

import { useFeatures } from '@/hooks/useFeatures';

import { getSnapshot, refreshWelcome, subscribe } from './api';

/**
 * The shared welcome payload, refreshed whenever a consumer mounts. The empty
 * chat mounts on every "New chat", so the brief is re-read then -- the same
 * moment the reader looks at it -- and never on a timer.
 */
export function useWelcome() {
  const { features, loading } = useFeatures();
  const enabled = !loading && !!features.topic_guide;
  const data = useSyncExternalStore(subscribe, getSnapshot);

  useEffect(() => {
    if (enabled) refreshWelcome();
  }, [enabled]);

  return { enabled, data: enabled ? data : null };
}
